import React from 'react';
import ReactDOM from 'react-dom';
import App from './views/App/App';
import * as serviceWorker from './serviceWorker';

import { Provider } from 'react-redux';
import store from './store';

import './css/font-awesome.min.css';
import './fonts/futura.css';
import './common.scss';
import 'react-modal-video/scss/modal-video.scss';
import "slick-carousel/slick/slick.css";
import 'swiper/swiper.scss'

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>, document.getElementById('root'));

serviceWorker.unregister();
